import { useCallback } from 'react';

import { useFetchShopItems } from '@swyftx/features/shop/api/hooks';

const useShopItems = () => {
  const { data, ...rest } = useFetchShopItems();

  const getItem = useCallback((id: string) => data?.items.find((i) => i.id === id), [data]);

  return { getItem, ...rest };
};

export { useShopItems };
